import React from "react"

const firstButton = {
  borderRadius: "5px 0 0 5px",
  marginRight: 0,
  backgroundColor: "white",
  color: "rgb(68, 68, 68)",
}

const MiddleButons = {
  borderRadius: 0,
  marginRight: 0,
  marginLeft: 0,
}

const lastButton = {
  borderRadius: "0 5px 5px 0",
  marginLeft: 0,
}

const Warehouse = () => {
  return (
    <div className='warehouse'>
      <div>
        <div className='header'>
          <i className='nc-icon nc-app' />
          <div>Warehouse</div>
        </div>
      </div>
      <ul>
        <li className='mb-3'>
          Select The terminal you are interested in
          <div className='mt-2'>
            <button className='btn btn-xs'>Laredo</button>
            <button className='btn btn-xs'>Carksville</button>
            <button className='btn btn-xs'>Taylor</button>
          </div>
        </li>
        <li className='mb-3'>
          Search for orders that are part of a bus, on dock or direct
          <div>
            <button className='btn btn-primary btn-xs' style={firstButton}>
              All
            </button>
            <button className='btn btn-primary btn-xs' style={MiddleButons}>
              Bus
            </button>
            <button className='btn btn-primary btn-xs' style={MiddleButons}>
              Dock
            </button>
            <button className='btn btn-primary btn-xs' style={lastButton}>
              Direct
            </button>
          </div>
        </li>
        <li className='mb-3'>
          Select orders that are incoming or outgoing and if it is a partial or
          not
          <div>
            <button className='btn btn-primary btn-xs' style={firstButton}>
              Incoming Orders
            </button>
            <button className='btn btn-primary btn-xs' style={MiddleButons}>
              Incoming Partials
            </button>
            <button className='btn btn-primary btn-xs' style={MiddleButons}>
              Outgoing Orders
            </button>
            <button className='btn btn-primary btn-xs' style={lastButton}>
              Outgoing Partials
            </button>
          </div>
        </li>
        <li className='mb-3'>
          Incoming and outgoing orders shows essential details for orders
        </li>
        <li className='mb-3'>
          Incoming and outgoing partials helps you track orders that have been
          divided into partials
        </li>
        <li className='mb-3'>
          Additional Options
          <div className='action'>
            <button className='btn btn-primary btn-xs mr-2'>P</button>
            <div>
              In <b>Outgoing Orders</b> you have the options to make partial
              orders
            </div>
          </div>
          <div className='action'>
            <button className='btn btn-primary btn-xs mr-2'>
              <i className='fa fa-file' />
            </button>
            <div>Print labels to post on skids</div>
          </div>
          <div className='action'>
            <button className='btn btn-primary btn-xs mr-2'>
              <i className='fa fa-print' />
            </button>
            <div>
              This pring the BOL in <b>Outgoing Orders</b>
            </div>
          </div>
          <div className='action'>
            <button className='btn btn-primary btn-xs mr-2'>
              <i className='fa fa-qrcode' />
            </button>
            <div>Take inventory of arriving and leaving orders</div>
          </div>
          <div className='action'>
            <button className='btn btn-primary btn-xs mr-2'>
              <i className='fa fa-camera' />
            </button>
            <div>
              Orders that are part of a CES bus can have the load and BOL
              photographed
            </div>
          </div>
          <div className='action'>
            <button className='btn btn-xs mr-2 warehouse'>Unload</button>
            <div>
              Mark an order as unloaded. Will remove the order from{" "}
              <b>Incoming Orders</b>
            </div>
          </div>
          <div className='action'>
            <button className='btn btn-xs mr-2 warehouse'>Load</button>
            <div>
              Mark an order as loaded and the order will be marked as complete.
              The order/bus will be removed from <b>All Orders</b>, <b>Buses</b>{" "}
              and <b>Warehouse</b>
            </div>
          </div>
        </li>
      </ul>
    </div>
  )
}

export default Warehouse
